import React from 'react'
import * as styles from './ContentSection.module.scss'

const ContentSection = ({ video, image, reverse, centered, icon, children }) => {
  return (
    <div className={styles.section}>
      <div className={styles.content}>
        <div>
          <div
            className={`${styles.row} ${reverse && styles.reverse} ${centered &&
              styles.centered}`}
          >
            <div className={styles.left}>
              <div>
                {icon && (
                  <div
                    className={styles.icon}
                    style={{ backgroundColor: icon.color }}
                  >
                    {typeof icon.src === 'string' ? (
                      <img src={icon.src} />
                    ) : (
                      icon.src
                    )}
                  </div>
                )}

                {children}
              </div>
            </div>
            {(video || image) && (
              <div className={`${styles.right} ${styles.reverse}`}>
                <div
                  className={`${styles.imageContainer} ${centered &&
                    styles.centered}`}
                >
                  {video ? (
                    <video
                      src={video}
                      loop
                      autoPlay
                      muted
                      playsInline={true}


                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 0,
                        display: 'block',
                        objectFit: 'cover',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        objectPosition: '50% 50%'
                      }}
                    ></video>
                  ) : (
                    <img src={image} alt="Content" />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentSection
